// eslint-disable-next-line import/order
import type { ComponentType, ClassAttributes, HTMLAttributes } from 'react';

import { styled, type StyledProps } from '@compiled/react';

// eslint-disable-next-line import/order
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AIWhoAnswerFooter: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
	// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled.div({
	paddingTop: token('space.300'),
	paddingRight: token('space.300'),
	paddingBottom: token('space.300'),
	paddingLeft: token('space.300'),
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'flex-start',
	borderTop: `${token('border.width')} solid ${token('color.border')}`,
	boxSizing: 'border-box',
});
